class LocalStorageKeys {
  static adminToken = "oookjghkjhfdkivhgrowihgiot-ioyrfiyityufygjgh-jhghhghj-hghguyjjhighjgjh-hgjkjhjkjkjk";
}
export default LocalStorageKeys;
